import React, { createContext, useContext, useState } from 'react';

const ApiConfigContext = createContext(null);

// Default API host for this documentation deployment. Override per-deployment by
// setting REACT_APP_API_BASE_URL at build time (e.g. https://api.stoneweg.lobees.com
// for a project-specific API running on its own subdomain).
export const DEFAULT_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.lobees.com';

export function ApiConfigProvider({ children }) {
  const [baseUrl, setBaseUrl] = useState(
    () => localStorage.getItem('api_base_url') || DEFAULT_API_BASE_URL
  );
  const [token, setToken] = useState(
    () => localStorage.getItem('api_token') || ''
  );

  const saveConfig = (url, tok) => {
    const clean = url.replace(/\/$/, '').trim() || DEFAULT_API_BASE_URL;
    setBaseUrl(clean);
    setToken(tok);
    localStorage.setItem('api_base_url', clean);
    localStorage.setItem('api_token', tok);
  };

  const resetToDefault = () => {
    setBaseUrl(DEFAULT_API_BASE_URL);
    localStorage.removeItem('api_base_url');
  };

  return (
    <ApiConfigContext.Provider
      value={{ baseUrl, token, saveConfig, resetToDefault, defaultBaseUrl: DEFAULT_API_BASE_URL }}
    >
      {children}
    </ApiConfigContext.Provider>
  );
}

export function useApiConfig() {
  return useContext(ApiConfigContext);
}
